var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('div',{staticStyle:{"position":"absolute","left":"10px","top":"10px","z-index":"99999","background-color":"white","padding":"3px"},on:{"click":_vm.send}},[_vm._v("调用android方法6")]),_vm._v(" "),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e4a25b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module-land/index.vue
// module id = null
// module chunks = 